var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSalesVersion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 5.28045C20.6616 4.97645 20.2386 4.80145 19.7916 4.80145H13.6516C13.0956 4.80145 12.5756 5.07245 12.2566 5.52745L9.48857 9.48245H6.50757C5.80257 9.48245 5.23157 10.0535 5.23157 10.7585V15.8645H7.78457",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8468 3.15301C18.5328 2.84801 18.1088 2.67401 17.6628 2.67401H11.5218C10.9668 2.67401 10.4468 2.94501 10.1268 3.40001L7.35976 7.35401H4.37976C3.67476 7.35401 3.10376 7.92501 3.10376 8.63101V13.737",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 1.02508C16.4048 0.721082 15.9818 0.546082 15.5348 0.546082H9.39481C8.83881 0.546082 8.31881 0.817082 7.99981 1.27208L5.23181 5.22708H2.25281C1.54781 5.22708 0.976807 5.79808 0.976807 6.50408V11.6101",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7422 15.0144C13.7422 16.6594 12.4082 17.9934 10.7632 17.9934C9.11818 17.9934 7.78418 16.6594 7.78418 15.0144C7.78418 13.3684 9.11818 12.0354 10.7632 12.0354C12.4082 12.0354 13.7422 13.3684 13.7422 15.0144Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7637 15.8649C10.2927 15.8649 9.91174 15.4839 9.91174 15.0139C9.91174 14.5439 10.2927 14.1629 10.7637 14.1629C11.2337 14.1629 11.6147 14.5439 11.6147 15.0139",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 15.8649H20.9752",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5519 8.32877V9.48177H12.0839L13.7429 7.11177C13.8239 6.99677 13.9519 6.92877 14.0929 6.92877H19.3479C19.4889 6.92877 19.6159 6.99677 19.6969 7.11177L20.5519 8.32877Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSalesVersion);
export default __webpack_public_path__ + "static/media/icon-sales-version.640257a5.svg";
export { ForwardRef as ReactComponent };